
export const UNIT_SYSTEM = {
  METRIC: 'METRIC',
  IMPERIAL: 'IMPERIAL',
}

export const UNIT_LABELS = {
  METRIC: 'm',
  IMPERIAL: 'mi'
}